import { c as _c } from "react/compiler-runtime";
import type { ApiCommunityMemberOverview } from "@/generated/models/ApiCommunityMemberOverview";
import type { SortDirection } from "@/entities/ISort";
import type { ApiCommunityMembersSortOption } from "@/generated/models/ApiCommunityMembersSortOption";
import CommunityMembersMobileCard from "./CommunityMembersMobileCard";
import CommunityMembersTableHeader from "./CommunityMembersTableHeader";
import CommunityMembersTableRow from "./CommunityMembersTableRow";
export default function CommunityMembersTable(t0) {
  const $ = _c(29);
  const {
    members,
    activeSort,
    sortDirection,
    page,
    pageSize,
    isLoading,
    onSort
  } = t0;
  let t1;
  if ($[0] !== activeSort || $[1] !== isLoading || $[2] !== onSort || $[3] !== sortDirection) {
    t1 = <CommunityMembersTableHeader activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} onSort={onSort} />;
    $[0] = activeSort;
    $[1] = isLoading;
    $[2] = onSort;
    $[3] = sortDirection;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== members || $[6] !== page || $[7] !== pageSize) {
    let t3;
    if ($[9] !== page || $[10] !== pageSize) {
      t3 = (member, index) => <CommunityMembersTableRow key={member.detail_view_key} member={member} rank={index + 1 + (page - 1) * pageSize} />;
      $[9] = page;
      $[10] = pageSize;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = members.map(t3);
    $[5] = members;
    $[6] = page;
    $[7] = pageSize;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[12] !== t2) {
    t3 = <tbody className="tw-divide-y tw-divide-solid tw-divide-iron-700">{t2}</tbody>;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t1 || $[15] !== t3) {
    t4 = <div className="tw-hidden sm:tw-block"><table className="tw-min-w-full">{t1}{t3}</table></div>;
    $[14] = t1;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== members || $[18] !== page || $[19] !== pageSize) {
    let t6;
    if ($[21] !== page || $[22] !== pageSize) {
      t6 = (member_0, index_0) => <CommunityMembersMobileCard key={member_0.detail_view_key} member={member_0} rank={index_0 + 1 + (page - 1) * pageSize} />;
      $[21] = page;
      $[22] = pageSize;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    t5 = members.map(t6);
    $[17] = members;
    $[18] = page;
    $[19] = pageSize;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[24] !== t5) {
    t6 = <div className="tw-mt-3 sm:tw-hidden"><div className="tw-flex tw-flex-col tw-gap-y-3">{t5}</div></div>;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== t4 || $[27] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[26] = t4;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
}